const STEPS = [
    { done: true, label: 'Submission received & secured' },
    { done: false, label: 'Finalizing verification results' },
]

const RetryDialog = ({ onSubmit }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(4px)' }}>

            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">

                {/* Header */}
                <div className="relative overflow-hidden bg-gradient-to-br from-slate-800 to-blue-900 px-8 pt-8 pb-10 text-white text-center">
                    {/* decorative circles */}
                    <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/5" />
                    <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-full bg-white/5" />

                    {/* animated shield */}
                    <div className="relative z-10 flex justify-center mb-5">
                        <div className="relative">
                            <div
                                className="absolute inset-0 rounded-full bg-blue-400/25 animate-ping"
                                style={{ animationDuration: '2.2s' }}
                            />
                            <div className="relative w-16 h-16 rounded-full bg-white/10 border border-white/20 flex items-center justify-center">
                                <svg className="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                        d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.96 11.96 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.153c-3.196 0-6.1-1.248-8.25-3.286z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <h2 className="relative z-10 text-lg font-bold tracking-tight mb-1">
                        Verification in Progress
                    </h2>
                    <p className="relative z-10 text-blue-200 text-xs leading-relaxed">
                        Running multi-layer checks to confirm your information
                    </p>
                </div>

                {/* animated scan line */}
                <div className="h-0.5 bg-slate-100 overflow-hidden relative">
                    <div
                        className="absolute inset-y-0 w-1/2 bg-gradient-to-r from-transparent via-blue-500 to-transparent animate-pulse"
                        style={{ animationDuration: '1.8s' }}
                    />
                </div>

                {/* Body */}
                <div className="px-7 py-6">

                    {/* step list */}
                    <ul className="space-y-3 mb-5">
                        {STEPS.map((step, i) => (
                            <li key={i} className="flex items-center gap-3">
                                {step.done ? (
                                    <span className="flex-shrink-0 w-5 h-5 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center">
                                        <svg className="w-2.5 h-2.5 text-emerald-500" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </span>
                                ) : (
                                    <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-50 border border-blue-200 flex items-center justify-center">
                                        <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" style={{ animationDuration: '1.2s' }} />
                                    </span>
                                )}
                                <span className={`text-sm ${step.done ? 'text-gray-400' : 'text-gray-700 font-medium'}`}>
                                    {step.label}
                                </span>
                            </li>
                        ))}
                    </ul>

                    <p className="text-center text-xs text-gray-400 leading-relaxed mb-6">
                        This thoroughness ensures the highest accuracy for your results.
                    </p>

                    <button
                        type="button"
                        onClick={onSubmit}
                        className="w-full py-3 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:opacity-90 active:scale-[0.98] transition-all duration-150 shadow-md shadow-blue-200"
                    >
                        Refresh Status
                    </button>
                </div>

            </div>
        </div>
    )
}

export default RetryDialog
